import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-22d15fe3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "d-flex flex-column ga-1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Status:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Created On:", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Published By:", -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Published On:", -1))
const _hoisted_9 = { class: "mt-4 d-flex align-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Order", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Approvers", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Status", -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Comment", -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Approve", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Reject", -1))
const _hoisted_18 = { class: "d-block mt-2" }

import { AssetManagementPlanApproval, User } from "@/classes";
import type { AssetManagementPlanMasterApprovalStage } from "@/classes/asset-management-plan";
import { useAMPStore } from "@/store/asset-management-plan";
import { useAuthStore } from "@/store/auth";
import { useListStore } from "@/store/lists";
import { computed, ref } from "vue";
import BaseDialog from "../base/dialogs/BaseDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'General',
  props: {
    readonly: { type: Boolean }
  },
  emits: ["refresh"],
  setup(__props: any, { emit: __emit }) {

const store = useAMPStore();
const lists = useListStore();
const users = lists.useList<User>("users");

const props = __props;

const emit = __emit;

const $auth = useAuthStore();

const showApproval = computed(() => {
  if (store.plan && store.plan.status === "In Review") return true;
  return false;
});

const approvable = (stage: AssetManagementPlanMasterApprovalStage) => {
  if (showApproval.value && store.plan.active_approval_stage?.id === stage.id) {
    return store.plan.active_approval_stage.approvers.some(
      (a) => a.user_id === $auth.state.user?.id,
    );
  }
  return false;
};

const approvalDialog = ref(false);
const approvingMode = ref(false);
const approvalName = ref("");
const approvalComment = ref("");

const openApprovalDialog = (approving: boolean) => {
  approvalDialog.value = true;
  approvingMode.value = approving;
  approvalName.value = `${$auth.state.user.first_name || ""} ${
    $auth.state.user.last_name || ""
  }`.trim();
  approvalComment.value = "";
};

const confirmingApproval = ref(false);
const confirmApproval = async () => {
  if (store.plan && store.plan.active_approval_stage) {
    confirmingApproval.value = true;
    const approval =
      store.plan.active_approval_stage.current_approval ||
      new AssetManagementPlanApproval();
    approval.stage_id = store.plan.active_approval_stage.id;
    approval.asset_management_plan_id = store.plan.id;
    approval.name = approvalName.value;
    approval.comment = approvalComment.value;
    approval.timestamp = new Date();
    approval.rejected = !approvingMode.value;
    approval.done = true;
    await approval.save();
    confirmingApproval.value = false;
    approvalDialog.value = false;
    emit("refresh");
  }
};

const publishedName = computed(() => {
  return (
    users.value.find((user) => user.id === store.plan.publisher_id)?.name || ""
  );
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_unref(store).plan.status), 1)
      ]),
      _createElementVNode("span", null, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_unref(store).plan.created.toLocaleString()), 1)
      ]),
      (publishedName.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(publishedName.value), 1)
          ]))
        : _createCommentVNode("", true),
      (_unref(store).plan.published_timestamp)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_unref(store).plan.published_timestamp.toLocaleString()), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_v_text_field, {
        class: "revision-input",
        modelValue: _unref(store).plan.revision,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).plan.revision) = $event)),
        density: "compact",
        variant: "outlined",
        label: "Revision",
        readonly: _ctx.readonly,
        "hide-details": ""
      }, null, 8, ["modelValue", "readonly"]),
      _renderSlot(_ctx.$slots, "revision-actions")
    ]),
    (_unref(store).plan.asset_management_plan_master.approval_stages.length > 0)
      ? (_openBlock(), _createBlock(_component_v_table, {
          key: 0,
          class: "mt-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _hoisted_10,
                _hoisted_11,
                _hoisted_12,
                (showApproval.value)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_13, "Approval"))
                  : _createCommentVNode("", true),
                _hoisted_14
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).plan.asset_management_plan_master
            .approval_stages, (stage) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: stage.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(stage.order + 1), 1),
                  _createElementVNode("td", null, _toDisplayString(stage.formatApprovers(_unref(users))), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_tooltip, {
                      location: "bottom",
                      text: stage.status_tooltip
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_chip, _mergeProps({ ref_for: true }, stage.status_tooltip ? props : {}, {
                          color: 
                    stage.status === 'Approved'
                      ? 'green'
                      : stage.status === 'Rejected'
                      ? 'red'
                      : ''
                  ,
                          label: ""
                        }), {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(stage.status), 1)
                          ]),
                          _: 2
                        }, 1040, ["color"])
                      ]),
                      _: 2
                    }, 1032, ["text"])
                  ]),
                  (showApproval.value)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                        _createVNode(_component_v_tooltip, { location: "bottom" }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, props, {
                              color: "green",
                              icon: "mdi-check",
                              variant: "text",
                              density: "compact",
                              disabled: !approvable(stage),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (openApprovalDialog(true)))
                            }), null, 16, ["disabled"])
                          ]),
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_tooltip, { location: "bottom" }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, props, {
                              class: "ml-1",
                              color: "red",
                              icon: "mdi-close",
                              variant: "text",
                              density: "compact",
                              disabled: !approvable(stage),
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (openApprovalDialog(false)))
                            }), null, 16, ["disabled"])
                          ]),
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("td", null, _toDisplayString(stage.comment), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(BaseDialog, {
      modelValue: approvalDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((approvalDialog).value = $event)),
      "max-width": "400",
      title: `${approvingMode.value ? 'Approve' : 'Reject'} Revision`
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          disabled: !approvalName.value,
          color: "primary",
          variant: "text",
          loading: confirmingApproval.value,
          onClick: confirmApproval
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Confirm ")
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_text_field, {
          modelValue: approvalName.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((approvalName).value = $event)),
          label: "Your Name",
          density: "compact",
          variant: "outlined",
          "hide-details": ""
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_text_field, {
          class: "mt-2",
          modelValue: approvalComment.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((approvalComment).value = $event)),
          label: "Comment",
          density: "compact",
          variant: "outlined",
          "hide-details": ""
        }, null, 8, ["modelValue"]),
        _createElementVNode("small", _hoisted_18, " I confirm that I am " + _toDisplayString(approvingMode.value ? "approving" : "rejecting") + " this revision. ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})